import { Component } from '@angular/core';
import { LayoutService } from 'app/services/layout.service';

@Component({
	selector: 'app-root-layout',
	standalone: false,
	template: `
		<ng-container *ngIf="layoutService.isNewLayout$ | async; else oldLayout">
			<app-main-layout></app-main-layout>
		</ng-container>
		<ng-template #oldLayout>
			<app-admin-layout></app-admin-layout>
		</ng-template>
	`,
})
export class RootLayoutComponent {
	constructor(public layoutService: LayoutService) {}
}
